import React, { useMemo } from "react";
import { map } from "lodash-es";

import { Sort } from "shared/assets/icons";
import { ISortingOptionKeys } from "Venues/types";
import { IActionSelectOption, ActionSelect } from "shared/components";
import { copy } from "shared/assets";
import { sortingOptions } from "Venues/utils";

const options: IActionSelectOption[] = map(ISortingOptionKeys, value => ({
  value,
  label: sortingOptions[value],
  dataTestId: value,
}));

interface SortByProps {
  sort: ISortingOptionKeys;
  onSortChange: (option: ISortingOptionKeys) => void;
}

export const SortBy: React.FC<SortByProps> = ({ sort, onSortChange }) => {
  const selectedOption = useMemo(() => {
    const value = sort;
    const label = sortingOptions[value];

    return {
      value,
      label,
    };
  }, [sort]);

  const onChange = (option: IActionSelectOption) => {
    onSortChange(option.value as ISortingOptionKeys);
  };

  return (
    <ActionSelect
      options={options}
      selectedOption={selectedOption}
      onChange={onChange}
      prefix={copy.searchPage.sort.prefix}
      icon={<Sort />}
      dataTestId="sort_action_select"
    />
  );
};
